import { cn } from '@/lib/cn';
import { NexaMark } from './nexa-mark';
import { NexaWordmark } from './nexa-wordmark';

export interface NexaLockupProps {
  className?: string;
}

/**
 * Nexa product lockup — mark + wordmark, the brand's one canonical pairing.
 * Static by construction (see NexaMark's 'brand' variant): chrome identity, not
 * a loading state. The wordmark inherits `currentColor`, so callers set the tone
 * with a text colour rather than swapping assets per theme.
 */
export function NexaLockup({ className }: NexaLockupProps) {
  return (
    <span className={cn('flex items-center gap-1.5', className)} data-testid="nexa-lockup">
      <NexaMark variant="brand" />
      {/* Both axes are pinned (615.05 × 107.09 ⇒ 5.74:1 at a 15px cap height):
          an SVG sized on one axis alone can collapse inside a flex row. */}
      <NexaWordmark className="h-[15px] w-[86px]" />
    </span>
  );
}
